<script lang="ts">
  import { nrkClose } from '@nrk/core-icons';
  import { closedCookieBanner } from '../util/cookie';
  import { i18n } from '../util/i18n/i18n';

  const onClose = () => {
    closedCookieBanner.set(true);
  };
</script>

{#if !$closedCookieBanner}
  <div class="cookie-banner">
    <div>
      <strong>{i18n('cookie-banner.bold')}</strong>
      {i18n('cookie-banner.pre-url')}
      <a
        href="https://info.nrk.no/informasjonskapsler/"
        target="_blank"
        referrerpolicy="no-referrer"
      >
        {i18n('cookie-banner.url')}
      </a>
      {i18n('cookie-banner.post-url')}
    </div>
    <button aria-label={i18n('cookie-banner.close')} on:click={onClose}>
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      <div class="remove-prefix">{@html nrkClose}</div>
    </button>
  </div>
{/if}

<style>
  .cookie-banner {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: var(--spacing-8);
    z-index: 1;
  }

  a {
    text-decoration: underline;
  }

  button {
    font-size: 1rem;
    padding: 0.25rem;
    background-color: transparent;
  }
</style>
